export default __webpack_public_path__ + "static/media/Penelope_9781408345160.4b8bb49d.jpg";